<template>
    <div class="Awards safe-distance-top">
        <div class="Awards_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">获奖情况</div>
            <div class="determine" @click="determine">提交</div>
        </div>
        <div class="Awards_bottom">
            <van-field
                v-model="awards"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入个人获奖情况"
                show-word-limit
                ref="input"
            />
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "Awards",
    data() {
        return {
            awards: "",
        };
    },
    created() {
        this.awardsId = this.$route.query.awardsId;
    },
    mounted() {
        // 回显
        this.awards = JSON.parse(sessionStorage.getItem("awardscontent"));
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        determine() {
            if (this.awards == "") {
                Toast("不能为空");
            } else {
                this.addOrEditPrize();
                window.history.go(-1);
            }
        },
        // 保存提交
        async addOrEditPrize() {
            let res = await this.$apis.userServe.addOrEditPrize({
                content: this.awards,
                id: this.awardsId,
            });
            if (res.data.resultCode == 200) {
                Toast("提交成功");
            } else {
                Toast(res.data.resultDesc);
            }
            console.log("是否成功?", res);
        },
    },
};
</script>

<style lang="scss" scoped>
.Awards {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .Awards_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .Awards_bottom {
        width: 94%;
        margin: 12px auto;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }
}
</style>
